import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../models/user";

type GlobalSliceType = {
  user: User | null;
};

const initialState: GlobalSliceType = {
  user: null,
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    resetGlobalState: () => ({ ...initialState }),
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
  },
});

export const { setUser, resetGlobalState } = globalSlice.actions;

export default globalSlice.reducer;
